import React from 'react';
import ConsumptionIndexMiniView, { ConsumptionIndexMiniViewProps } from './ConsumptionIndexMiniView';
import useLastConsumptionIndexFormatted from '../../../../features/Jouly/hooks/core/useLastConsumptionIndexFormatted';

export interface ConsumptionIndexMiniPresenterProps {
  deviceId?: string;
}

export default function ConsumptionIndexMiniPresenter({
  deviceId
}: ConsumptionIndexMiniPresenterProps) {
  const { 
    consumptionIndexValue, 
    formattedConsumptionIndex, 
    consumptionIndexStatus, 
    consumptionIndexTime, 
    isLoading 
  } = useLastConsumptionIndexFormatted(deviceId);

  if (isLoading) {
    return <>...</>
  }

  const viewProps: ConsumptionIndexMiniViewProps = {
    consumptionIndexValue,
    formattedConsumptionIndex,
    consumptionIndexStatus,
    deviceId,
    consumptionIndexTime
  };

  return <ConsumptionIndexMiniView {...viewProps} />;
}

